import React, { useState } from 'react';
import { View, Pressable } from 'react-native';
import { useQuery } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import DataState from 'app/src/components/DataState';
import Modal from 'app/src/elements/Modal';
import {
  DownloadButton,
  downloadReport,
} from 'app/src/elements/ReportDownload';
import { Text } from 'app/src/styles';

import Registered from './Registered';
import { SALE_LOT_BUYERS } from './queries';

const Lots = ({ saleId }) => {
  const [showRegistered, setShowRegistered] = useState(false);

  const { data } = useQuery(SALE_LOT_BUYERS, {
    variables: { id: saleId }
  });

  if (!data) { return <DataState.Loading />; }

  const lotBuyers = data.sale.lotBuyers.map(({ ...entry }) => {
    entry.registered = entry.visits.filter(visit => visit.buyerUser);
    entry.guests = entry.visits.filter(visit => !visit.buyerUser);
    return entry;
  });

  const columns = [
    {
      key: 'lotNumber',
      label: 'Lot #',
      value: ({ entry }) => entry.saleAsset.lotNumber,
    },
    {
      key: 'asset',
      label: 'Asset',
      value: ({ entry }) => entry.saleAsset.asset.name,
    },
    {
      key: 'startAt',
      label: 'Start Bidding',
      content: ({ value }) => (
        value ? moment(value).format('MM-DD-YY \@ hh:mmA') : ''
      )
    },
    {
      key: 'registered',
      label: 'Registered Buyers',
      value: ({ value }) => value.length,
      content: ({ value, entry }) => (
        <Pressable
          style={{ flexDirection: 'row', gap: 10 }}
          onPress={() => {
            setShowRegistered(entry.registered.map(visit => visit.buyerUser))
          }}
        >
          <Text>{value}</Text>
          <FontAwesomeIcon icon={faMagnifyingGlass} size="sm" />
        </Pressable>
      )
    },
    {
      key: 'guests',
      label: 'Guest Viewers',
      value: ({ value }) => value.length,
    },
    {
      key: 'assetViews',
      label: 'Buyers Viewed Asset Before Sale',
      value: ({ value }) => value.length,
      content: ({ value, entry }) => (
        <Pressable
          style={{ flexDirection: 'row', gap: 10 }}
          onPress={() => {
            setShowRegistered(entry.assetViews.map(view => view.buyerUser))
          }}
        >
          <Text>{value}</Text>
          <FontAwesomeIcon icon={faMagnifyingGlass} size="sm" />
        </Pressable>
      )
    },
    {
      key: 'watching',
      label: 'Buyers Watching',
      value: ({ value }) => value.length,
      content: ({ value, entry }) => (
        <Pressable
          style={{ flexDirection: 'row', gap: 10 }}
          onPress={() => {
            setShowRegistered(entry.watching.map(view => view.buyerUser))
          }}
        >
          <Text>{value}</Text>
          <FontAwesomeIcon icon={faMagnifyingGlass} size="sm" />
        </Pressable>
      )
    }
  ];

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'sale-lot-buyers-report',
      params: { 'sale-id': saleId }
    })
  };

  return (
    <View>
      <DataTable.Simple
        data={lotBuyers}
        columns={columns}
        pageLength="All"
        htmlTable
        sortOnArrowClickOnly
        buttons={<DownloadButton handleDownload={handleDownload} />}
      />
      {showRegistered && (
        <Modal
          showModal={showRegistered}
          setShowModal={setShowRegistered}
          modalType="Registered Buyers"
        >
          <Registered buyerUsers={showRegistered} />
        </Modal>
      )}
    </View>
  );
};

export default Lots;
